import { lazy, Suspense } from 'react';

import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface MailingPolicyProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * M3 — Политика рассылки.
 * Источник: docs/legal/mailing_policy.md.
 * Lazy-load (см. PrivacyPolicy.tsx).
 */
const MailingPolicyContent = lazy(() => import('./legal/MailingPolicyContent'));

export function MailingPolicy({ isOpen, onClose }: MailingPolicyProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Политика рассылки">
      <div className="flex flex-col gap-3">
        <Suspense fallback={<LegalContentFallback />}>
          {isOpen && <MailingPolicyContent />}
        </Suspense>
        <div className="pt-2">
          <Button onClick={onClose} fullWidth size="md">
            Понятно
          </Button>
        </div>
      </div>
    </Modal>
  );
}

function LegalContentFallback() {
  return (
    <div className="flex justify-center py-8" aria-label="Загрузка текста">
      <span
        role="status"
        className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-border border-t-accent"
      />
    </div>
  );
}
